import { useMemo } from 'react';
import UISideNav from 'UIComponents/nav/UISideNav';
import UniversalAssociationsSelectSideNavItem from './UniversalAssociationsSelectSideNavItem';
import UniversalAssociationsSelectSideAllAssociationsNavItem from './UniversalAssociationsSelectSideAllAssociationsNavItem';
import { StyledWrapper, StyledHR } from './UniversalAssociationsSelectSideNavSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UniversalAssociationsSelectSideNav = ({
  associationRecords,
  allAssociationsCount,
  selectedObjectTypeId,
  onSetSelectedObjectTypeId
}) => {
  const objectTypesNavList = useMemo(() => {
    if (!associationRecords) {
      return null;
    }
    const navItems = associationRecords.map(association => /*#__PURE__*/_jsx(UniversalAssociationsSelectSideNavItem, {
      association: association,
      selectedObjectTypeId: selectedObjectTypeId,
      onSetSelectedObjectTypeId: onSetSelectedObjectTypeId
    }, `association-nav-${association.get('toObjectTypeId')}`)).valueSeq();
    return /*#__PURE__*/_jsx(UISideNav, {
      "aria-label": "Other Associations",
      className: "m-bottom-0 m-top-1",
      children: navItems
    });
  }, [associationRecords, onSetSelectedObjectTypeId, selectedObjectTypeId]);
  return /*#__PURE__*/_jsxs(StyledWrapper, {
    className: "p-bottom-2 p-left-3 p-top-2 overflow-y-scroll",
    children: [/*#__PURE__*/_jsx(UISideNav, {
      "aria-label": "Selected Associations",
      className: "m-bottom-0 m-top-0",
      children: /*#__PURE__*/_jsx(UniversalAssociationsSelectSideAllAssociationsNavItem, {
        allAssociationsCount: allAssociationsCount,
        selectedObjectTypeId: selectedObjectTypeId,
        onSetSelectedObjectTypeId: onSetSelectedObjectTypeId
      })
    }), /*#__PURE__*/_jsx(StyledHR, {
      distance: "flush"
    }), objectTypesNavList]
  });
};
export default UniversalAssociationsSelectSideNav;